// /* eslint-disable no-extra-boolean-cast */
// import { useAppDispatch } from '@store/hooks';
// import { useFormik } from 'formik';
// import { useTranslation } from 'react-i18next';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { Form } from 'react-bootstrap';
// import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts';
// import Select from 'react-select';
// import { addApBankAccounts, getApBankAccountsList } from '@store/Finance/AP/ApBankAccounts/ApBankAccountsSlice';
// import Loading from '@components/Shared/Loader/Loading';
// import { AddCashBoxesSchema } from '../../../ValidationForm/validationSchema';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';

// const Add = () => {
//   const { i18n, t } = useTranslation();
//   const dispatch = useAppDispatch();
//   const { OptionsAccounts, loading, error } = useGetAccounts();

//   const { OperatingUnitOptions, loading: loading1, error: error1 } = useGetOperatingUnitWithPermission();

//   const formik = useFormik({
//     initialValues: {
//       ntxBankId: 'F700CF22-AF84-4CA2-AC8C-C3BEF5B88325',
//       name: '',
//       name2: '',
//       description: '',
//       // bankAccount: '',
//       accountId: '',
//       // iban: '',
//       accountReconcileId: '',
//       organizationId: ''
//     },
//     validationSchema: AddCashBoxesSchema(t),
//     onSubmit: values => {
//       dispatch(
//         addApBankAccounts({
//           ntxBankId: 'F700CF22-AF84-4CA2-AC8C-C3BEF5B88325', // خاص بصناديق النقدية
//           name: values.name,
//           name2: values.name2,
//           bankAccount: '',
//           iban: '',
//           description: values.description,
//           accountId: values.accountId,
//           accountReconcileId: values.accountReconcileId
//         })
//       )
//         .unwrap()
//         .then((res: any) => {
//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Add' });
//             document.getElementById('closeModalForm')?.click();
//             dispatch(getApBankAccountsList());
//             formik.resetForm();
//           } else {
//             formik.setSubmitting(false);
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch((error: any) => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error' });
//         });
//     }
//   });

//   const { values, errors, touched } = formik;

//   return (
//     <>
//       <Loading loading={loading} error={error}>
//         <Form onSubmit={formik.handleSubmit}>
//           <div className='row'>
//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('LocalName')}</label>
//                 <Form.Control
//                   className='form-control  '
//                   type='text'
//                   autoComplete='off'
//                   name='name2'
//                   onChange={formik.handleChange}
//                   value={formik.values.name2}
//                   isInvalid={!!(formik.touched.name2 && formik.errors.name2)}
//                 />
//                 <div className='text-danger small'>{touched.name2 && errors.name2}</div>
//               </div>
//             </div>
//             <div className='col-xl-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('GlobalName')}</label>
//                 <Form.Control
//                   className='form-control  '
//                   type='text'
//                   autoComplete='off'
//                   name='name'
//                   onChange={formik.handleChange}
//                   value={formik.values.name}
//                   isInvalid={!!(formik.touched.name && formik.errors.name)}
//                 />
//                 <div className='text-danger small'>{touched.name && errors.name}</div>
//               </div>
//             </div>

//             <div className='col-xl-6 '>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('Accounts')}</label>
//                 <Select
//                   classNamePrefix='react-select'
//                   className={`w-100 ${
//                     !!(formik.touched.accountId && formik.errors.accountId) ? 'border border-danger' : ''
//                   } `}
//                   isLoading={loading}
//                   isSearchable={true}
//                   isClearable
//                   name='accountId'
//                   options={OptionsAccounts}
//                   placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                   onChange={(option: any) => {
//                     formik.setFieldValue('accountId', option === null ? null : option.value);
//                   }}
//                   value={OptionsAccounts?.find(f => f.value === formik.values.accountId)}
//                 />
//                 <div className='text-danger small'>{touched.accountId && errors.accountId}</div>
//               </div>
//             </div>
//             <div className='col-xl-6 '>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('حسـاب التسـوية')}</label>
//                 <Select
//                   classNamePrefix='react-select'
//                   className={`w-100 ${
//                     !!(formik.touched.accountId && formik.errors.accountId) ? 'border border-danger' : ''
//                   } `}
//                   isLoading={loading}
//                   isSearchable={true}
//                   isClearable
//                   name='accountReconcileId'
//                   options={OptionsAccounts}
//                   placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                   onChange={(option: any) => {
//                     formik.setFieldValue('accountReconcileId', option === null ? null : option.value);
//                   }}
//                   value={OptionsAccounts?.find(f => f.value === formik.values.accountReconcileId)}
//                 />
//                 <div className='text-danger small'>{touched.accountReconcileId && errors.accountReconcileId}</div>
//               </div>
//             </div>

//           </div>

//           <div className='text-center mt-2'>
//             <div className='d-flex justify-content-between gap-2'>
//               <button
//                 disabled={formik.isSubmitting}
//                 type='submit'
//                 className='btn btn-lg btn-theme mb-1 w-100 rounded-0'
//               >
//                 {formik.isSubmitting ? (
//                   <div className='spinner-border spinner-border-sm me-2'></div>
//                 ) : (
//                   <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
//                 )}
//                 {t('Add')}
//               </button>
//               <button
//                 type='button'
//                 className='btn btn-lg  btn-default mb-1 w-100 rounded-0'
//                 data-bs-dismiss='modal'
//                 id='closeModalForm'
//               >
//                 <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//               </button>
//             </div>
//           </div>
//         </Form>
//       </Loading>
//     </>
//   );
// };

// export default Add;

/* eslint-disable no-extra-boolean-cast */
import { useAppDispatch } from '@store/hooks';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { Form } from 'react-bootstrap';
import useGetAccounts from '@hooks/Finance/ChartAccountsDetails/useGetAccounts';
import Select from 'react-select';
import { addApBankAccounts, getApBankAccountsList } from '@store/Finance/AP/ApBankAccounts/ApBankAccountsSlice';
import Loading from '@components/Shared/Loader/Loading';
import { AddCashBoxesSchema } from '../../../ValidationForm/validationSchema';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';

const Add = () => {
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();
  const { OptionsAccounts, loading, error } = useGetAccounts();
  const { OperatingUnitOptions, loading: loading1, error: error1 } = useGetOperatingUnitWithPermission();

  const formik = useFormik({
    initialValues: {
      ntxBankId: 'F700CF22-AF84-4CA2-AC8C-C3BEF5B88325',
      name: '',
      name2: '',
      description: '',
      accountId: null,
      accountReconcileId: null,
      organizationId: null
    },
    validationSchema: AddCashBoxesSchema(t),
    onSubmit: values => {
      dispatch(
        addApBankAccounts({
          ntxBankId: 'F700CF22-AF84-4CA2-AC8C-C3BEF5B88325', // خاص بصناديق النقدية
          name: values.name,
          name2: values.name2,
          bankAccount: '',
          iban: '',
          description: values.description,
          accountId: values.accountId,
          accountReconcileId: values.accountReconcileId,
          organizationId: values.organizationId // ✅ الجديد
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            document.getElementById('closeModalForm')?.click();
            dispatch(getApBankAccountsList());
            formik.resetForm();
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch(() => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const { values, errors, touched } = formik;

  const isAnyLoading = loading || loading1;
  const anyError = error || error1;

  return (
    <>
      <Loading loading={isAnyLoading} error={anyError}>
        <Form onSubmit={formik.handleSubmit}>
          <div className='row'>
            {/* ✅ Operating Unit => organizationId */}

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('LocalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name2'
                  onChange={formik.handleChange}
                  value={values.name2}
                  isInvalid={!!(touched.name2 && errors.name2)}
                />
                <div className='text-danger small'>{touched.name2 && errors.name2}</div>
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('GlobalName')}</label>
                <Form.Control
                  className='form-control'
                  type='text'
                  autoComplete='off'
                  name='name'
                  onChange={formik.handleChange}
                  value={values.name}
                  isInvalid={!!(touched.name && errors.name)}
                />
                <div className='text-danger small'>{touched.name && errors.name}</div>
              </div>
            </div>
            
            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('OperatingUnit') || t('Operating Unit') || 'Operating Unit'}</label>
                <Select
                  classNamePrefix='react-select'
                  className={`w-100 ${
                    !!(touched.organizationId && errors.organizationId) ? 'border border-danger' : ''
                  }`}
                  isLoading={loading1}
                  isSearchable
                  isClearable
                  name='organizationId'
                  options={OperatingUnitOptions}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  onChange={(option: any) => {
                    formik.setFieldValue('organizationId', option ? option.value : null);
                  }}
                  value={OperatingUnitOptions?.find((f: any) => f.value === values.organizationId) ?? null}
                />
                <div className='text-danger small'>{touched.organizationId && (errors.organizationId as any)}</div>
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('Accounts')}</label>
                <Select
                  classNamePrefix='react-select'
                  className={`w-100 ${!!(touched.accountId && errors.accountId) ? 'border border-danger' : ''}`}
                  isLoading={loading}
                  isSearchable
                  isClearable
                  name='accountId'
                  options={OptionsAccounts}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  onChange={(option: any) => {
                    formik.setFieldValue('accountId', option ? option.value : null);
                  }}
                  value={OptionsAccounts?.find((f: any) => f.value === values.accountId) ?? null}
                />
                <div className='text-danger small'>{touched.accountId && (errors.accountId as any)}</div>
              </div>
            </div>

            <div className='col-xl-6'>
              <div className='form-group mb-3'>
                <label className='form-label'>{t('حسـاب التسـوية')}</label>
                <Select
                  classNamePrefix='react-select'
                  className={`w-100 ${
                    !!(touched.accountReconcileId && errors.accountReconcileId) ? 'border border-danger' : ''
                  }`}
                  isLoading={loading}
                  isSearchable
                  isClearable
                  name='accountReconcileId'
                  options={OptionsAccounts}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  onChange={(option: any) => {
                    formik.setFieldValue('accountReconcileId', option ? option.value : null);
                  }}
                  value={OptionsAccounts?.find((f: any) => f.value === values.accountReconcileId) ?? null}
                />
                <div className='text-danger small'>
                  {touched.accountReconcileId && (errors.accountReconcileId as any)}
                </div>
              </div>
            </div>
          </div>

          <div className='text-center mt-2'>
            <div className='d-flex justify-content-between gap-2'>
              <button
                disabled={formik.isSubmitting}
                type='submit'
                className='btn btn-lg btn-theme mb-1 w-100 rounded-0'
              >
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
                )}
                {t('Add')}
              </button>

              <button
                type='button'
                className='btn btn-lg btn-default mb-1 w-100 rounded-0'
                data-bs-dismiss='modal'
                id='closeModalForm'
              >
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </div>
        </Form>
      </Loading>
    </>
  );
};

export default Add;
